import React, { FC, memo } from 'react';
import { Container, Title } from './styles';
import { Props } from './types';

const SectionHeading: FC<Props> = ({ title, className }) => (
  <Container className={className}>
    <Title>{title}</Title>
  </Container>
);

export default memo(SectionHeading);
